import { makeAutoObservable, runInAction } from "mobx";
import i18n from "i18next";
import MainStore from "MainStore";
import { deleteOutgoingDocument } from "api/OutgoingDocument";
import { getOutgoingDocumentsByApprovalRequest, downloadFile } from "api/OutgoingDocument";
import {getSignByFileId} from "../../../api/File";
import {
  getSignersByDocumentId,
  searchUsersForSigner,
  createSigner,
  deleteSigner
} from "api/outgoing_document_signer";

class NewStore {
  data = [];
  openPanel = false;
  currentId = 0;
  idMain = 0;
  isEdit = false;
    ecpListOpen = false;
    signData = [];

  File = null;
  fileType = '';
  fileUrl = null;
  isOpenFileView = false;

  // Диалог назначения подписантов
  signerDialogOpen = false;
  signerDialogDocId: number | null = null;
  signerDialogSigners = [];
  signerSearchOptions = [];
  signerSearchLoading = false;

  constructor() {
    makeAutoObservable(this);
  }

  onEditClicked(id: number) {
    this.openPanel = true;
    this.currentId = id;
  }

  closePanel() {
    this.openPanel = false;
    this.currentId = 0;
  }

  setFastInputIsEdit = (value: boolean) => {
    this.isEdit = value;
  }

  async loadOutgoingDocuments() {
    try {
      MainStore.changeLoader(true);
      const response = await getOutgoingDocumentsByApprovalRequest(this.idMain);
      if ((response.status === 201 || response.status === 200) && response?.data !== null) {
        this.data = response.data;
      } else {
        throw new Error();
      }
    } catch (err) {
      MainStore.setSnackbar(i18n.t("message:somethingWentWrong"), "error");
    } finally {
      MainStore.changeLoader(false);
    }
  };

  deleteOutgoingDocument(id: number) {
    MainStore.openErrorConfirm(
      i18n.t("areYouSure"),
      i18n.t("delete"),
      i18n.t("no"),
      async () => {
        try {
          MainStore.changeLoader(true);
          const response = await deleteOutgoingDocument(id);
          if (response.status === 201 || response.status === 200) {
            this.loadOutgoingDocuments();
            MainStore.setSnackbar(i18n.t("message:snackbar.successSave"));
          } else {
            throw new Error();
          }
        } catch (err) {
          MainStore.setSnackbar(i18n.t("message:somethingWentWrong"), "error");
        } finally {
          MainStore.changeLoader(false);
          MainStore.onCloseConfirm();
        }
      },
      () => MainStore.onCloseConfirm()
    );
  };


  downloadFile = async (id: number, fileName: string) => {
    try {
      MainStore.changeLoader(true);
      const response = await downloadFile(id);
      if ((response.status === 201 || response.status === 200) && response?.data !== null) {
        const byteCharacters = atob(response.data.fileContents);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: response.data.contentType || 'application/octet-stream' });

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', response.data.fileDownloadName || fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } else {
        throw new Error();
      }
    } catch (err) {
      MainStore.setSnackbar(i18n.t("message:somethingWentWrong"), "error");
    } finally {
      MainStore.changeLoader(false);
    }
  };

    async OpenFileFile(idFile: number, fileName) {
    try {
      MainStore.changeLoader(true);
      const response = await downloadFile(idFile);
      if ((response.status === 201 || response.status === 200) && response?.data !== null) {
        const byteCharacters = atob(response.data.fileContents);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        let mimeType = 'application/pdf';
        this.fileType = 'pdf';
        if (fileName.endsWith('.png')) {
          mimeType = 'image/png';
          this.fileType = 'png';
        }
        if (fileName.endsWith('.jpg') || fileName.endsWith('.jpeg')) {
          mimeType = 'image/jpeg';
          this.fileType = 'jpg';
        }
        const blob = new Blob([byteArray], { type: mimeType });
        this.fileUrl = URL.createObjectURL(blob);
        this.isOpenFileView = true;
        return
      } else {
        throw new Error();
      }
    } catch (err) {
      MainStore.setSnackbar(i18n.t("message:somethingWentWrong"), "error");
    } finally {
      MainStore.changeLoader(false);
    }
  }

  clearStore() {
    runInAction(() => {
      this.data = [];
      this.currentId = 0;
      this.openPanel = false;
      this.idMain = 0;
      this.isEdit = false;
    });
  };

  openSignerDialog = async (docId: number) => {
    this.signerDialogDocId = docId;
    this.signerDialogOpen = true;
    await this.loadSigners(docId);
  };

  closeSignerDialog = () => {
    this.signerDialogOpen = false;
    this.signerDialogDocId = null;
    this.signerDialogSigners = [];
    this.signerSearchOptions = [];
  };

  loadSigners = async (docId: number) => {
    try {
      const response = await getSignersByDocumentId(docId);
      if ((response.status === 200 || response.status === 201) && response?.data) {
        runInAction(() => { this.signerDialogSigners = response.data; });
      }
    } catch (err) {
      MainStore.setSnackbar(i18n.t("message:somethingWentWrong"), "error");
    }
  };

  searchSignerUsers = async (query: string) => {
    if (!query.trim()) { this.signerSearchOptions = []; return; }
    try {
      this.signerSearchLoading = true;
      const response = await searchUsersForSigner(query);
      if ((response.status === 200 || response.status === 201) && response?.data) {
        runInAction(() => { this.signerSearchOptions = response.data; });
      }
    } catch (err) {
      // ignore
    } finally {
      runInAction(() => { this.signerSearchLoading = false; });
    }
  };

  addSigner = async (userAccountId: number) => {
    if (!this.signerDialogDocId) return;
    try {
      MainStore.changeLoader(true);
      await createSigner({ outgoing_document_id: this.signerDialogDocId, user_account_id: userAccountId });
      await this.loadSigners(this.signerDialogDocId);
      this.signerSearchOptions = [];
    } catch (err) {
      MainStore.setSnackbar(i18n.t("message:somethingWentWrong"), "error");
    } finally {
      MainStore.changeLoader(false);
    }
  };

  removeSigner = async (signerId: number) => {
    if (!this.signerDialogDocId) return;
    try {
      MainStore.changeLoader(true);
      const response = await deleteSigner(signerId);
      if (response.status === 200 || response.status === 201) {
        await this.loadSigners(this.signerDialogDocId);
      } else {
        const msg = response.data?.message || i18n.t("message:somethingWentWrong");
        MainStore.setSnackbar(msg, "error");
      }
    } catch (err: any) {
      const msg = err?.response?.data?.message || i18n.t("message:somethingWentWrong");
      MainStore.setSnackbar(msg, "error");
    } finally {
      MainStore.changeLoader(false);
    }
  };

    signApplicationPayment(fileId: number, uplId: number, onSaved: () => void) {
        MainStore.digitalSign.fileId = fileId;
        MainStore.digitalSign.uplId = uplId;
        MainStore.openDigitalSign(
            fileId,
            async () => {
                MainStore.onCloseDigitalSign();
                onSaved()
            },
            () => MainStore.onCloseDigitalSign(),
        );
    };

    async loadGetSignByFileId(id) {
        try {
            MainStore.changeLoader(true);
            const response = await getSignByFileId(id);
            if ((response.status === 201 || response.status === 200) && response?.data !== null) {
                this.signData = response.data;
            } else {
                throw new Error();
}
        } catch (err) {
            MainStore.setSnackbar(i18n.t("message:somethingWentWrong"), "error");
        } finally {
            MainStore.changeLoader(false);
        }
    };
}

export default new NewStore();